import { useMutation, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import type {
  CddDataFull,
  GetCddDataQueryParams,
  PostApiCddDataMutationVariables,
  PostCddDataQueryParams,
} from './cdd.api.types';

export type { CddDataFull, GetCddDataQueryParams, PostCddDataQueryParams } from './cdd.api.types';

export const getCddDataApi = async ({ customerId }: GetCddDataQueryParams) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/cdd`
    : `v3/secureonboarding/user/${customerId}/cdd`;
  const { data } = await HttpService.get<CddDataFull>(url);
  return data;
};

export const postCddDataApi = async ({ payload, customerId }: PostApiCddDataMutationVariables) => {
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/cdd`
    : `v3/secureonboarding/user/${customerId}/cdd`;
  const { data } = await HttpService.post<unknown>(url, payload);
  return data;
};

export const useGetCddDataQuery = ({ customerId }: GetCddDataQueryParams) =>
  useSuspenseQuery({
    queryKey: ['getCddData', customerId],
    queryFn: ({ queryKey: [_, id] }) => getCddDataApi({ customerId: id }),
  });

export const useUpdateCddData = ({ customerId }: PostCddDataQueryParams) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['postCddData', customerId],
    mutationFn: (variables: Partial<CddDataFull>) =>
      postCddDataApi({ payload: variables, customerId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCddData', customerId] });
    },
  });
};
